<template>
    <v-text-field
        :id="'address' + this._uid"
        autocomplete="false"
        v-model="value.search"
        :rules="isRequired ? [rules.required, /*fiasLevelCheckRule,*/ cityCheckRule, streetCheckRule, houseCheckRule/*, postalCheckRule*/] : []"
        :messages="fiasWarning"
        :label="label"
        validate-on-blur
        :disabled="isDisabled"
        :required="isRequired"
    ></v-text-field>
</template>

<script>
    import $ from 'jquery';
    import 'suggestions-jquery';
    export default {
        props: {
            model: {
                required: true
            },
            options: {
                type: Object,
                default: () => ({
                    //token: 'd41d36d28500ad106eddbdc20258ec57d945f1d1',
                    token: '14a86f53aaa54b7bb802c4f1b895a59ba2006b30',
                    type: 'ADDRESS',
                    addon: 'spinner',
                    count: 5,
                    minChars: 2,
                    floating: true,
                }),
            },
            short: {
                default: false,
            },
            label: {
                default: 'Город, улица, дом, квартира',
            },
            goToElement: {
                default: true
            },
            checkHouseFiasLevel: {
                default: false
            },
            isDisabled: {
                default: false
            },
            isRequired: {
                default: true
            }
        },

        data: () => ({
            element: null,
            init: false,
            value: '',
            flatTip: false,
            fiasWarning: "",
            rules: {
                required: v => !this.isRequired || !!v || 'Обязательное поле',
            },
        }),

        computed: {
            cityCheckRule() {
                return () => !!this.value.city || 'Нужно указать населенный пункт';
            },
            streetCheckRule() {
                return () => !!this.value.street || 'Нужно указать улицу';
            },
            houseCheckRule() {
                return () => !!this.value.house || 'Проверьте корректность ввода номера дома';
            },
            postalCheckRule() {
                return () => !!this.value.postalCode || 'Адрес отсутствует в справочнике: проверьте правильность введенных данных';
            },
            fiasLevelCheckRule() {
                return () => !this.checkHouseFiasLevel ||
                    this.value.fiasLevel === 8 || this.value.fiasLevel === 9 ||
                    'Адреса дома нет в ФИАС. Чтобы улучшить одобрение полиса подберите адрес на сайте fias.nalog.ru';
            }
        },

        mounted() {
            this.options.onSelect = suggestion => this.onSelectAddress(suggestion);
            this.options.scrollOnFocus = this.goToElement !== false;
            this.value = this.model;
            this.element = $('#address'+this._uid);
            this.$nextTick(() => {
                this.initSuggestion();
            });
        },

        destroyed() {
            this.destroySuggestion();
        },

        watch: {
            value() {
                this.$emit('update:model', this.value);
            },
            model() {
                this.value = this.model;
            },
        },

        methods: {
            initSuggestion() {
                if (this.init) {
                    return;
                }
                const plugin = this.element.suggestions(this.options);
                if (this.value.search) {
                    const data = {
                        query: this.value.search,
                        count: 1
                    };
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.options.token
                    };
                    axios.post(
                        plugin.suggestions().options.serviceUrl + '/suggest/address',
                        data,
                        {headers: headers}
                    ).then(response => {
                        if (response && response.data && response.data.suggestions && response.data.suggestions.length) {
                            this.onSelectAddress(response.data.suggestions[0]);
                        } else {
                            console.log(response);
                        }
                    }).catch(error => {
                        console.log(error)
                    });
                }
                this.init = true;
            },
            destroySuggestion() {
                this.element.suggestions().dispose();
            },
            onSelectAddress(suggestion) {
                this.value.search = suggestion.value;
                this.value.full = suggestion.unrestricted_value || '';
                this.value.region = suggestion.data.region_with_type || '';
                this.value.regionFias = suggestion.data.region_fias_id || '';
                this.value.regionKladr = suggestion.data.region_kladr_id || '';
                this.value.city = suggestion.data.city_with_type || suggestion.data.settlement_with_type || '';
                this.value.cityKladr = suggestion.data.city_kladr_id || suggestion.data.settlement_kladr_id || '';
                if (this.value.cityKladr.length > 13) {
                    this.value.cityKladr = this.value.cityKladr.substring(0, 13);
                }
                this.value.cityFias = suggestion.data.city_fias_id || '';
                this.value.settlementKladr = suggestion.data.settlement_kladr_id || '';
                this.value.settlementFias = suggestion.data.settlement_fias_id || '';
                this.value.street = suggestion.data.street_with_type || suggestion.data.settlement_with_type || '';
                this.value.streetKladr = suggestion.data.street_kladr_id || suggestion.data.settlement_kladr_id || '';
                this.value.streetFias = suggestion.data.street_fias_id || suggestion.data.settlement_fias_id || '';
                this.value.house = suggestion.data.house ? (suggestion.data.house_type + ' ' + suggestion.data.house) : '';
                this.value.house += suggestion.data.block ? (' ' + suggestion.data.block_type + ' ' + suggestion.data.block) : '';
                this.value.houseFias = suggestion.data.house_fias_id || '';
                this.value.flat = suggestion.data.flat || '';
                this.value.postalCode = suggestion.data.postal_code || '';
                this.value.fiasLevel = suggestion.data.fias_level || '';
                this.value.fias = suggestion.data.fias_id || '';
                this.value.kladr = suggestion.data.kladr_id || '';
                this.value.okato = suggestion.data.okato || '';
                this.value.area = suggestion.data.area || '';

                if (parseInt(this.value.fiasLevel) <= 7){
                    this.fiasWarning = 'Адреса дома нет в ФИАС. Чтобы улучшить одобрение полиса подберите адрес на сайте fias.nalog.ru';
                } else if (!parseInt(this.value.postalCode)){
                  this.fiasWarning = 'Адрес отсутствует в справочнике: проверьте правильность введенных данных';
                } else {
                    this.fiasWarning = '';
                }
            },
        }
    };
</script>
<style>
    .v-messages__message {
        color: #ff5252
    }
    .message-transition-enter-to {
        color: #ff5252 !important;
        caret-color: #ff5252 !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/fields/AddressDadata.vue